import { Injectable } from '@angular/core';

import { NavigationService } from '@core/services/navigation/navigation.service';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class ReopenCardCommand extends BaseProductCommand {
  readonly type = 'reopen';
  readonly title = 'Перевыпустить';
  readonly icon = 'refresh';
  readonly productType = ProductTypes.CARD;
  readonly isInfoAction = true;
  readonly settingsNames = ['REQUEST/REOPEN_CARD'];

  get order(): number {
    return this.getContextualOrder({
      [ProductTypes.CARD]: 40           // Карты: Перевыпустить (4-й в списке "прочее")
    }, 999);
  }

  constructor(
    private navigationService: NavigationService,
    commandAvailabilityService: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push(`product/${context.data.id}/reopen-card`, {
      state: {
        productCode: context.data.productCode
      }
    });
  }
}

